// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: agent_config.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AgentType, agentTypeFromJSON, agentTypeToJSON } from "./agent";

export const protobufPackage = "com.darwin.eva";

export enum ReasoningEffortLevel {
  /**
   * REASONING_NOT_VALID - TODO: add support for non-OpenAI models later
   * Reasoning effort is not set for the model
   */
  REASONING_NOT_VALID = 0,
  /** NONE - Reasoning model will not do reasoning */
  NONE = 1,
  /** MINIMAL - Reasoning model will do minimal level reasoning */
  MINIMAL = 2,
  /** LOW - Reasoning model will do low level reasoning */
  LOW = 3,
  /** MEDIUM - Reasoning model will do medium level reasoning */
  MEDIUM = 4,
  /** HIGH - Reasoning model will do high level reasoning */
  HIGH = 5,
  /** XHIGH - Reasoning model will do extremely high level reasoning - introduced with 5.2 openai model */
  XHIGH = 6,
  UNRECOGNIZED = -1,
}

export function reasoningEffortLevelFromJSON(object: any): ReasoningEffortLevel {
  switch (object) {
    case 0:
    case "REASONING_NOT_VALID":
      return ReasoningEffortLevel.REASONING_NOT_VALID;
    case 1:
    case "NONE":
      return ReasoningEffortLevel.NONE;
    case 2:
    case "MINIMAL":
      return ReasoningEffortLevel.MINIMAL;
    case 3:
    case "LOW":
      return ReasoningEffortLevel.LOW;
    case 4:
    case "MEDIUM":
      return ReasoningEffortLevel.MEDIUM;
    case 5:
    case "HIGH":
      return ReasoningEffortLevel.HIGH;
    case 6:
    case "XHIGH":
      return ReasoningEffortLevel.XHIGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ReasoningEffortLevel.UNRECOGNIZED;
  }
}

export function reasoningEffortLevelToJSON(object: ReasoningEffortLevel): string {
  switch (object) {
    case ReasoningEffortLevel.REASONING_NOT_VALID:
      return "REASONING_NOT_VALID";
    case ReasoningEffortLevel.NONE:
      return "NONE";
    case ReasoningEffortLevel.MINIMAL:
      return "MINIMAL";
    case ReasoningEffortLevel.LOW:
      return "LOW";
    case ReasoningEffortLevel.MEDIUM:
      return "MEDIUM";
    case ReasoningEffortLevel.HIGH:
      return "HIGH";
    case ReasoningEffortLevel.XHIGH:
      return "XHIGH";
    case ReasoningEffortLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PromptConfig {
  /** Unique identifier for the prompt */
  id?:
    | string
    | undefined;
  /** Display name of the prompt */
  name?:
    | string
    | undefined;
  /** Model type */
  model_type?:
    | string
    | undefined;
  /** Model Name */
  model_name?:
    | string
    | undefined;
  /** Reasoning effort level */
  reasoning_effort?:
    | ReasoningEffortLevel
    | undefined;
  /** Model temperature */
  temperature?:
    | number
    | undefined;
  /** Philosophy - part of prompt */
  philosophy?:
    | string
    | undefined;
  /** instructions - part of prompt */
  instructions?:
    | string
    | undefined;
  /** Version number of the prompt */
  version?:
    | number
    | undefined;
  /** Flag to check if prompt is active */
  is_active?:
    | boolean
    | undefined;
  /** Created timestamp for prompt create */
  created_date?:
    | number
    | undefined;
  /** Modified timestamp for prompt update */
  modified_date?: number | undefined;
}

export interface ToolConfig {
  /** Unique identifier for the tool */
  id?:
    | string
    | undefined;
  /** Display name of the tool */
  name?:
    | string
    | undefined;
  /** Name used within the agent context */
  name_in_agent?:
    | string
    | undefined;
  /** Human-readable description of what the tool does */
  description?:
    | string
    | undefined;
  /** JSON schema defining the tool's input arguments */
  args_schema_json?:
    | string
    | undefined;
  /** Current version number of the tool */
  version?: number | undefined;
}

export interface AgentConfig {
  /** Unique identifier for the agent */
  id?:
    | string
    | undefined;
  /** Display name of the agent */
  name?:
    | string
    | undefined;
  /** Flag to check if agent is active */
  is_active?:
    | boolean
    | undefined;
  /** Human-readable description of what the agent does */
  description?:
    | string
    | undefined;
  /** Type of agent (TISA, TIGA, PLAN, etc.) */
  agent_type?:
    | AgentType
    | undefined;
  /** All analysis flags values as JSON schema */
  analysis_flag?:
    | string
    | undefined;
  /** Version number of the agent */
  version?:
    | number
    | undefined;
  /** Prompt config field */
  prompt_config?:
    | PromptConfig
    | undefined;
  /** Related tools list */
  tools: ToolConfig[];
}

export interface Pagination {
  /** Total number of items available */
  total?:
    | number
    | undefined;
  /** Current offset/starting position */
  offset?:
    | number
    | undefined;
  /** Whether there are more items beyond current page */
  has_more?: boolean | undefined;
}

export interface AgentListResponseWrapper {
  /** List of agents matching the request criteria */
  agents: AgentConfig[];
  /** Pagination metadata for the response */
  pagination?: Pagination | undefined;
}

export interface ToolListResponseWrapper {
  /** List of tools matching the request criteria */
  tools: ToolConfig[];
  /** Pagination metadata for the response */
  pagination?: Pagination | undefined;
}

export interface GenerateSystemPromptRequest {
  /** Type of agent (TISA, TIGA, PLAN, etc.) */
  agent_type?:
    | AgentType
    | undefined;
  /** Base system prompt (philosophy + instructions) */
  prompt?:
    | string
    | undefined;
  /** Different analysis flags */
  analysis_flag?:
    | string
    | undefined;
  /** Agent-specific input data */
  agent_params?: string | undefined;
}

function createBasePromptConfig(): PromptConfig {
  return {
    id: undefined,
    name: undefined,
    model_type: undefined,
    model_name: undefined,
    reasoning_effort: undefined,
    temperature: undefined,
    philosophy: undefined,
    instructions: undefined,
    version: undefined,
    is_active: undefined,
    created_date: undefined,
    modified_date: undefined,
  };
}

export const PromptConfig: MessageFns<PromptConfig> = {
  encode(message: PromptConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.model_type !== undefined) {
      writer.uint32(26).string(message.model_type);
    }
    if (message.model_name !== undefined) {
      writer.uint32(34).string(message.model_name);
    }
    if (message.reasoning_effort !== undefined) {
      writer.uint32(40).int32(message.reasoning_effort);
    }
    if (message.temperature !== undefined) {
      writer.uint32(53).float(message.temperature);
    }
    if (message.philosophy !== undefined) {
      writer.uint32(58).string(message.philosophy);
    }
    if (message.instructions !== undefined) {
      writer.uint32(66).string(message.instructions);
    }
    if (message.version !== undefined) {
      writer.uint32(72).int32(message.version);
    }
    if (message.is_active !== undefined) {
      writer.uint32(80).bool(message.is_active);
    }
    if (message.created_date !== undefined) {
      writer.uint32(88).int64(message.created_date);
    }
    if (message.modified_date !== undefined) {
      writer.uint32(96).int64(message.modified_date);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PromptConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePromptConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.model_type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.model_name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.reasoning_effort = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.philosophy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.instructions = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.version = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.is_active = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.created_date = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.modified_date = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PromptConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      model_type: isSet(object.model_type) ? globalThis.String(object.model_type) : undefined,
      model_name: isSet(object.model_name) ? globalThis.String(object.model_name) : undefined,
      reasoning_effort: isSet(object.reasoning_effort)
        ? reasoningEffortLevelFromJSON(object.reasoning_effort)
        : undefined,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : undefined,
      philosophy: isSet(object.philosophy) ? globalThis.String(object.philosophy) : undefined,
      instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : undefined,
      is_active: isSet(object.is_active) ? globalThis.Boolean(object.is_active) : undefined,
      created_date: isSet(object.created_date) ? globalThis.Number(object.created_date) : undefined,
      modified_date: isSet(object.modified_date) ? globalThis.Number(object.modified_date) : undefined,
    };
  },

  toJSON(message: PromptConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.model_type !== undefined) {
      obj.model_type = message.model_type;
    }
    if (message.model_name !== undefined) {
      obj.model_name = message.model_name;
    }
    if (message.reasoning_effort !== undefined) {
      obj.reasoning_effort = reasoningEffortLevelToJSON(message.reasoning_effort);
    }
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    if (message.philosophy !== undefined) {
      obj.philosophy = message.philosophy;
    }
    if (message.instructions !== undefined) {
      obj.instructions = message.instructions;
    }
    if (message.version !== undefined) {
      obj.version = Math.round(message.version);
    }
    if (message.is_active !== undefined) {
      obj.is_active = message.is_active;
    }
    if (message.created_date !== undefined) {
      obj.created_date = Math.round(message.created_date);
    }
    if (message.modified_date !== undefined) {
      obj.modified_date = Math.round(message.modified_date);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PromptConfig>, I>>(base?: I): PromptConfig {
    return PromptConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PromptConfig>, I>>(object: I): PromptConfig {
    const message = createBasePromptConfig();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.model_type = object.model_type ?? undefined;
    message.model_name = object.model_name ?? undefined;
    message.reasoning_effort = object.reasoning_effort ?? undefined;
    message.temperature = object.temperature ?? undefined;
    message.philosophy = object.philosophy ?? undefined;
    message.instructions = object.instructions ?? undefined;
    message.version = object.version ?? undefined;
    message.is_active = object.is_active ?? undefined;
    message.created_date = object.created_date ?? undefined;
    message.modified_date = object.modified_date ?? undefined;
    return message;
  },
};

function createBaseToolConfig(): ToolConfig {
  return {
    id: undefined,
    name: undefined,
    name_in_agent: undefined,
    description: undefined,
    args_schema_json: undefined,
    version: undefined,
  };
}

export const ToolConfig: MessageFns<ToolConfig> = {
  encode(message: ToolConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.name_in_agent !== undefined) {
      writer.uint32(26).string(message.name_in_agent);
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.args_schema_json !== undefined) {
      writer.uint32(42).string(message.args_schema_json);
    }
    if (message.version !== undefined) {
      writer.uint32(48).int32(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name_in_agent = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.args_schema_json = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.version = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      name_in_agent: isSet(object.name_in_agent) ? globalThis.String(object.name_in_agent) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      args_schema_json: isSet(object.args_schema_json) ? globalThis.String(object.args_schema_json) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : undefined,
    };
  },

  toJSON(message: ToolConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.name_in_agent !== undefined) {
      obj.name_in_agent = message.name_in_agent;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.args_schema_json !== undefined) {
      obj.args_schema_json = message.args_schema_json;
    }
    if (message.version !== undefined) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolConfig>, I>>(base?: I): ToolConfig {
    return ToolConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolConfig>, I>>(object: I): ToolConfig {
    const message = createBaseToolConfig();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.name_in_agent = object.name_in_agent ?? undefined;
    message.description = object.description ?? undefined;
    message.args_schema_json = object.args_schema_json ?? undefined;
    message.version = object.version ?? undefined;
    return message;
  },
};

function createBaseAgentConfig(): AgentConfig {
  return {
    id: undefined,
    name: undefined,
    is_active: undefined,
    description: undefined,
    agent_type: undefined,
    analysis_flag: undefined,
    version: undefined,
    prompt_config: undefined,
    tools: [],
  };
}

export const AgentConfig: MessageFns<AgentConfig> = {
  encode(message: AgentConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.is_active !== undefined) {
      writer.uint32(24).bool(message.is_active);
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    if (message.agent_type !== undefined) {
      writer.uint32(40).int32(message.agent_type);
    }
    if (message.analysis_flag !== undefined) {
      writer.uint32(50).string(message.analysis_flag);
    }
    if (message.version !== undefined) {
      writer.uint32(56).int32(message.version);
    }
    if (message.prompt_config !== undefined) {
      PromptConfig.encode(message.prompt_config, writer.uint32(66).fork()).join();
    }
    for (const v of message.tools) {
      ToolConfig.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.is_active = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.analysis_flag = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.version = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.prompt_config = PromptConfig.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.tools.push(ToolConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentConfig {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      is_active: isSet(object.is_active) ? globalThis.Boolean(object.is_active) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      agent_type: isSet(object.agent_type) ? agentTypeFromJSON(object.agent_type) : undefined,
      analysis_flag: isSet(object.analysis_flag) ? globalThis.String(object.analysis_flag) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : undefined,
      prompt_config: isSet(object.prompt_config) ? PromptConfig.fromJSON(object.prompt_config) : undefined,
      tools: globalThis.Array.isArray(object?.tools) ? object.tools.map((e: any) => ToolConfig.fromJSON(e)) : [],
    };
  },

  toJSON(message: AgentConfig): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.is_active !== undefined) {
      obj.is_active = message.is_active;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.agent_type !== undefined) {
      obj.agent_type = agentTypeToJSON(message.agent_type);
    }
    if (message.analysis_flag !== undefined) {
      obj.analysis_flag = message.analysis_flag;
    }
    if (message.version !== undefined) {
      obj.version = Math.round(message.version);
    }
    if (message.prompt_config !== undefined) {
      obj.prompt_config = PromptConfig.toJSON(message.prompt_config);
    }
    if (message.tools?.length) {
      obj.tools = message.tools.map((e) => ToolConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentConfig>, I>>(base?: I): AgentConfig {
    return AgentConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentConfig>, I>>(object: I): AgentConfig {
    const message = createBaseAgentConfig();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.is_active = object.is_active ?? undefined;
    message.description = object.description ?? undefined;
    message.agent_type = object.agent_type ?? undefined;
    message.analysis_flag = object.analysis_flag ?? undefined;
    message.version = object.version ?? undefined;
    message.prompt_config = (object.prompt_config !== undefined && object.prompt_config !== null)
      ? PromptConfig.fromPartial(object.prompt_config)
      : undefined;
    message.tools = object.tools?.map((e) => ToolConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBasePagination(): Pagination {
  return { total: undefined, offset: undefined, has_more: undefined };
}

export const Pagination: MessageFns<Pagination> = {
  encode(message: Pagination, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.total !== undefined) {
      writer.uint32(8).int32(message.total);
    }
    if (message.offset !== undefined) {
      writer.uint32(16).int32(message.offset);
    }
    if (message.has_more !== undefined) {
      writer.uint32(24).bool(message.has_more);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pagination {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePagination();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.total = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.offset = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.has_more = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pagination {
    return {
      total: isSet(object.total) ? globalThis.Number(object.total) : undefined,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
      has_more: isSet(object.has_more) ? globalThis.Boolean(object.has_more) : undefined,
    };
  },

  toJSON(message: Pagination): unknown {
    const obj: any = {};
    if (message.total !== undefined) {
      obj.total = Math.round(message.total);
    }
    if (message.offset !== undefined) {
      obj.offset = Math.round(message.offset);
    }
    if (message.has_more !== undefined) {
      obj.has_more = message.has_more;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Pagination>, I>>(base?: I): Pagination {
    return Pagination.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pagination>, I>>(object: I): Pagination {
    const message = createBasePagination();
    message.total = object.total ?? undefined;
    message.offset = object.offset ?? undefined;
    message.has_more = object.has_more ?? undefined;
    return message;
  },
};

function createBaseAgentListResponseWrapper(): AgentListResponseWrapper {
  return { agents: [], pagination: undefined };
}

export const AgentListResponseWrapper: MessageFns<AgentListResponseWrapper> = {
  encode(message: AgentListResponseWrapper, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.agents) {
      AgentConfig.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentListResponseWrapper {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentListResponseWrapper();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.agents.push(AgentConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentListResponseWrapper {
    return {
      agents: globalThis.Array.isArray(object?.agents) ? object.agents.map((e: any) => AgentConfig.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? Pagination.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: AgentListResponseWrapper): unknown {
    const obj: any = {};
    if (message.agents?.length) {
      obj.agents = message.agents.map((e) => AgentConfig.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = Pagination.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentListResponseWrapper>, I>>(base?: I): AgentListResponseWrapper {
    return AgentListResponseWrapper.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentListResponseWrapper>, I>>(object: I): AgentListResponseWrapper {
    const message = createBaseAgentListResponseWrapper();
    message.agents = object.agents?.map((e) => AgentConfig.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseToolListResponseWrapper(): ToolListResponseWrapper {
  return { tools: [], pagination: undefined };
}

export const ToolListResponseWrapper: MessageFns<ToolListResponseWrapper> = {
  encode(message: ToolListResponseWrapper, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tools) {
      ToolConfig.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolListResponseWrapper {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolListResponseWrapper();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tools.push(ToolConfig.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolListResponseWrapper {
    return {
      tools: globalThis.Array.isArray(object?.tools) ? object.tools.map((e: any) => ToolConfig.fromJSON(e)) : [],
      pagination: isSet(object.pagination) ? Pagination.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ToolListResponseWrapper): unknown {
    const obj: any = {};
    if (message.tools?.length) {
      obj.tools = message.tools.map((e) => ToolConfig.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = Pagination.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolListResponseWrapper>, I>>(base?: I): ToolListResponseWrapper {
    return ToolListResponseWrapper.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolListResponseWrapper>, I>>(object: I): ToolListResponseWrapper {
    const message = createBaseToolListResponseWrapper();
    message.tools = object.tools?.map((e) => ToolConfig.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGenerateSystemPromptRequest(): GenerateSystemPromptRequest {
  return { agent_type: undefined, prompt: undefined, analysis_flag: undefined, agent_params: undefined };
}

export const GenerateSystemPromptRequest: MessageFns<GenerateSystemPromptRequest> = {
  encode(message: GenerateSystemPromptRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_type !== undefined) {
      writer.uint32(8).int32(message.agent_type);
    }
    if (message.prompt !== undefined) {
      writer.uint32(18).string(message.prompt);
    }
    if (message.analysis_flag !== undefined) {
      writer.uint32(26).string(message.analysis_flag);
    }
    if (message.agent_params !== undefined) {
      writer.uint32(34).string(message.agent_params);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateSystemPromptRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateSystemPromptRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.analysis_flag = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.agent_params = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateSystemPromptRequest {
    return {
      agent_type: isSet(object.agent_type) ? agentTypeFromJSON(object.agent_type) : undefined,
      prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : undefined,
      analysis_flag: isSet(object.analysis_flag) ? globalThis.String(object.analysis_flag) : undefined,
      agent_params: isSet(object.agent_params) ? globalThis.String(object.agent_params) : undefined,
    };
  },

  toJSON(message: GenerateSystemPromptRequest): unknown {
    const obj: any = {};
    if (message.agent_type !== undefined) {
      obj.agent_type = agentTypeToJSON(message.agent_type);
    }
    if (message.prompt !== undefined) {
      obj.prompt = message.prompt;
    }
    if (message.analysis_flag !== undefined) {
      obj.analysis_flag = message.analysis_flag;
    }
    if (message.agent_params !== undefined) {
      obj.agent_params = message.agent_params;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateSystemPromptRequest>, I>>(base?: I): GenerateSystemPromptRequest {
    return GenerateSystemPromptRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateSystemPromptRequest>, I>>(object: I): GenerateSystemPromptRequest {
    const message = createBaseGenerateSystemPromptRequest();
    message.agent_type = object.agent_type ?? undefined;
    message.prompt = object.prompt ?? undefined;
    message.analysis_flag = object.analysis_flag ?? undefined;
    message.agent_params = object.agent_params ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
